module.exports = __webpack_public_path__ + "media/images/favicon-3b3d4a0a6689f392b6214f9a01a3446e.ico";